export default __webpack_public_path__ + "static/2021_Best_Digital_Game-ff23c0e9a703978a618b682b696766d6.png";